import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FolderOpen, ArrowRight } from "lucide-react";
import { PublicLayout } from "../components/Common";
import api from "../lib/api";

export default function Categories() {
  const [cats, setCats] = useState(null);
  useEffect(() => {
    document.title = "Kategori - DS KODE";
    api.get("/categories").then((r) => setCats(r.data)).catch(() => setCats([]));
  }, []);
  return (
    <PublicLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="font-heading text-3xl font-extrabold text-slate-900">Kategori Produk</h1>
        <p className="text-slate-500 mt-1 mb-8">Jelajahi produk berdasarkan kategori.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(cats || Array.from({ length: 9 })).map((c, i) =>
            c ? (
              <Link key={c.id} to={`/products?category_id=${c.id}`} data-testid={`category-${c.id}`} className="group bg-white rounded-xl border border-slate-200/80 p-5 hover:border-indigo-300 hover:shadow-lg transition-all flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="grid place-items-center h-11 w-11 rounded-lg bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-colors"><FolderOpen className="h-5 w-5" /></span>
                  <div>
                    <h3 className="font-heading font-semibold text-slate-900">{c.name}</h3>
                    <p className="text-xs text-slate-500">{c.product_count} produk</p>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-slate-300 group-hover:text-indigo-600 group-hover:translate-x-1 transition-all" />
              </Link>
            ) : (
              <div key={i} className="h-20 skeleton rounded-xl" />
            )
          )}
        </div>
      </div>
    </PublicLayout>
  );
}
